<util-progress [bar]="true" *ngIf="loading"></util-progress>
<div class="row">
  <div *ngFor="let  n of notifications?.content; index as i"
  [ngClass]="i%2===0 && notifications.content.length-1===i?'col-sm-12':'col-sm-6'"
  >
    <div class="card" style="background-color: {{n.background_color}};color: {{n.text_color}};">
      <div class="row no-gutters align-items-center">
        <div class="col-sm-4" *ngIf="n.image!=null && i%2==0">
          <img class="card-img img-fluid" src="{{n.image}}" alt="Card image">
        </div>
        <div [ngClass]="n.image==null?'col-sm-12':'col-sm-8'">
          <div class="card-body">
            <h5 class="card-title">{{n.title}}</h5>
            <h6 class="card-text" [innerHTML]="n.description"></h6>
            <h6 class="card-text">
              <i class="mdi {{resolveAlertIcon(n.priority)}} me-2"></i>
              <small>{{n.priority}} PRIORITY</small>
            </h6>
          </div>
          <div class="card-body">
            <a href="javascript: void(0);" style="color: {{n.text_color}};" class="card-link" (click)="dismissNotification(n.id)">
              DISMISS
            </a>
            <a *ngIf="n.redirect_url" href="{{n.redirect_url}}" target="_blank" class="card-link">
              VISIT URL <i class="bx bx-link-external"></i>
            </a>
            <a class="card-link" style="color: {{n.action_color}};" data-bs-toggle="collapse" href="#respondBox" aria-expanded="false" aria-controls="respondBox">
              RESPOND
            </a>
            <div class="collapse hiding mt-2" id="respondBox">
              <div class="card border shadow-none card-body text-muted mb-0">
                <ckeditor
                  id="response"
                  [editor]="Editor"
                  [(ngModel)]="response"
                  [maxlength]="511"
                ></ckeditor>
<!--                <textarea class="form-control input-group-text" rows="6" [(ngModel)]="response" maxlength="511"></textarea>-->
              </div>
              <button class="btn btn-primary mt-2 pull-right" (click)="onResponseSubmit(n.id)">SUBMIT</button>
              <button class="btn btn-secondary mt-2 ms-2 pull-right" data-bs-toggle="collapse" href="#respondBox" aria-expanded="false" aria-controls="respondBox">CLOSE</button>
            </div>
          </div>
        </div>
        <div class="col-sm-4" *ngIf="n.image!=null && i%2==1">
          <img class="card-img img-fluid" src="{{n.image}}" alt="Card image">
        </div>
      </div>
    </div>
  </div>
</div>
